import { render, staticRenderFns } from "./Validity.vue?vue&type=template&id=68b812f2&scoped=true&"
import script from "./Validity.vue?vue&type=script&lang=js&"
export * from "./Validity.vue?vue&type=script&lang=js&"
import style0 from "./Validity.vue?vue&type=style&index=0&id=68b812f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b812f2",
  null
  
)

export default component.exports